import { SVGIcon } from '@superops/super-icons';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React from 'react';

function ApprovalByDetailsCell(props) {
  const { cell } = props;
  const { value } = cell;
  if (isEmpty(value)) {
    return <TextStyle variation="subdued">NA</TextStyle>;
  }

  const { approvalBy, name: approvalName } = value;
  if (approvalBy === 'User') {
    return (
      <div className="flex actr">
        <div className="mr10">
          <Avatar
            initials={approvalName.slice(0, 1).toUpperCase()}
            name={approvalName}
            size="extraSmall"
          />
        </div>
        <div className="ellipsis" title={approvalName}>
          {approvalName}
        </div>
      </div>
    );
  }
  return (
    <div className="flex actr g5">
      <SVGIcon name="PolicyLight" />
      <div>{approvalName}</div>
    </div>
  );
}
export default ApprovalByDetailsCell;
